import { connect } from 'react-redux';
import * as constants from 'constants';
import ProfileMenu from 'comp/left/settings_list';
import { isWeb } from 'core';

const mapToProps = state => ({
  isSelected: {
    account: state.ui.selected_settings_item === constants.SETTINGS_ITEMS.ACCOUNT,
    support: state.ui.selected_settings_item === constants.SETTINGS_ITEMS.SUPPORT,
    suggestions: state.ui.selected_settings_item === constants.SETTINGS_ITEMS.SUGGESTIONS,
    devices: state.ui.selected_settings_item === constants.SETTINGS_ITEMS.DEVICES
  }
});

export default connect(mapToProps)(ProfileMenu);



// WEBPACK FOOTER //
// ./src/containers/left/SettingsList.js